
import { useEffect } from 'react';
import { pageTitle } from '../../helpers/PageTitle';
import DepartmentSectionStyle2 from '../Section/DepartmentSection/DepartmentSectionStyle2';
import Spacing from '../Spacing';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../../redux/user/userSlice';
import {
    useNavigate,
    useLocation
} from 'react-router-dom';

const healthcare = [
    {
        title: '24/7 Specialist Access',
        subTitle: 'Unlimited online consultations with a wide range of healthcare professionals.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Unlimited doctor consults',
        subTitle: 'Free unlimited doctor consultations across various specialties.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Dedicated Family Doctor',
        subTitle: 'Personalized care from a chosen family doctor for tailored healthcare.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Exclusive Wellness Programs',
        subTitle: 'Access to curated health programs, including early disease detection and wellness advice.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Diagnostic & Pharmacy Benefits',
        subTitle: 'Access reliable tests, diagnostics, and medications through a cost-effective healthcare experience.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Personalized Doctor Selection',
        subTitle: 'Suggest your preferred doctor and facility for inclusion, unless they opt out.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Your Wellbeing Matters',
        subTitle: 'We prioritize your physical, mental health, and overall wellbeing for a fulfilling life.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Empowering Middle-Aged Wellness',
        subTitle: 'Tailored tips for better balance, agility, and strength, reducing fall risks.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Efficient Health Solutions',
        subTitle: 'Save time and money, focus on essentials, access curated health programs.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Health Risk Assessments',
        subTitle: 'Track your well-being with dynamic health scores and a personalized health journey.',
        iconUrl: '/images/icons/calendar_white.svg'
    }
];

const complementary = [
    {
        title: 'Extensive Insurance Coverage',
        subTitle: 'Comprehensive health and accident insurance with added benefits and coverage.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Exclusive Insurance for Subscribers',
        subTitle: 'Free: Up to 30 Lakhs health insurance & 10 Lakhs personal accident coverage.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Coverage: 91 Days to 65 Years',
        subTitle: 'Insurance available for individuals aged 91 days to 65 years.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'No Medical Check-up Needed',
        subTitle: 'Onboard based on a Good Health Declaration, no check-ups required.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Day 1 Pre-existing Coverage',
        subTitle: 'Day 1 coverage for pre-existing conditions, with waived waiting periods.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Provide Ambulance Coverage',
        subTitle: 'Receive ambulance coverage up to Rs 5000 per person.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Ayush Treatment: Up to 25% FSI',
        subTitle: 'Coverage for Ayush treatments, up to 25% of FSI in recognized hospitals.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Pre & Post Hospitalisation',
        subTitle: 'Receive coverage for medical expenses incurred before and after hospitalisation.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'COVID Home Care',
        subTitle: 'Access home-based treatment for COVID-19, ensuring comfort and safety during recovery',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Access to Healthy Diet Recipes',
        subTitle: 'Free Access to Healthy Diet Recipes to complement your fitness journey.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Meditation Sessions, Health Podcasts, and Expert-led Sessions',
        subTitle: 'Free meditation sessions, Health Podcasts, and Expert-led Sessions to support your overall wellness.',
        iconUrl: '/images/icons/calendar_white.svg'
    }
];

const valueAdded = [
    {
        title: 'Critical Illness Coverage',
        subTitle: 'Rs 5 lakh payout for 15 critical diseases. Protect your health and finances.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Hospital Stay Cash Benefit',
        subTitle: 'Rs 3000/- daily for stays over 24 hours, up to 90 days, alongside insurance.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: '1200+ At-Home Workouts',
        subTitle: 'Yoga, Dance Fitness, Strength &Conditioning (S&C), HRX, High-Intensity Interval Training (HIIT), Walk Fitness, Cardio, Boxing, Pilates, and Equipment-based workouts.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Complete Fitness & Wellness Support',
        subTitle: '1200+ at-home workouts, free meditation sessions, expert podcasts, and healthy diet recipes—all in one place for your overall well-being.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Your Security, Our Priority',
        subTitle: 'We safeguard your privacy—no data sales, no compromises.',
        iconUrl: '/images/icons/calendar_white.svg'
    },
    {
        title: 'Exclusive Discounts Delivered',
        subTitle: 'Enjoy special savings on a variety of products and services, delivered straight to you.',
        iconUrl: '/images/icons/calendar_white.svg'
    }
];


const scrollToHash = () => {
    const hash = window.location.hash;
    if (hash) {
        const element = document.getElementById(hash.replace("#", ""));
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    }
};


export default function Benefits() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);
    const location = useLocation();

    useEffect(() => {
        scrollToHash();
    }, [location]);
    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            // Wait for DOM to render (important!)
            setTimeout(() => {
                const id = hash.replace("#", "");
                const element = document.getElementById(id);
                if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                }
            }, 100); // Slight delay helps if DOM is not yet ready
        }
    }, []);
    useEffect(() => {
        const scrollToHash = () => {
            const hash = window.location.hash;
            if (hash) {
                const id = hash.replace("#", "");
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth" });
                }
            }
        };

        if (document.readyState === "complete") {
            scrollToHash();
        } else {
            window.addEventListener("load", scrollToHash);
            return () => window.removeEventListener("load", scrollToHash);
        }
    }, []);


    const handleGetStarted = () => {
        if (user?.success && user?.user?.token) {
            dispatch(logoutUser());
        }
        localStorage.setItem('popup', 'true');
        navigate('/', { state: { showPopup: true } });

    }

    pageTitle('Benefits');

    return (
        <>
            <div style={{ backgroundColor: '#0e6ebe', margin: '0px', maxWidth: '100vw', display: 'flex', flexDirection: 'column', justifyContent: 'start', minWidth: '100vw', padding: '0px 0px 50px 0px' }}>

                <Spacing md="125" />
                <div className="container" style={{ backgroundColor: '#0e6ebe', margin: '0px', maxWidth: '100vw', display: 'flex', justifyContent: 'center' }}>
                    <div className="cs_banner_text row">
                        <div className='col-xl-6 col-md-12'>
                            <h2 className="cs_banner_title cs_fs_72" style={{ color: '#fff' }}>Find the Right Plan for You</h2>
                            <p className="cs_banner_subtitle cs_fs_20 mb-0 cs_heading_color" style={{ color: '#fff' }}>
                                Explore Our Membership Options and Start Your Journey to Better Health
                            </p>
                        </div>
                        <div className='col-xl-6 col-md-12 text-center'>
                            <Spacing md="50" lg="50" xl="100" />
                            <div className={`cs_btn cs_style_1`} onClick={handleGetStarted} style={{ color: '#0e6ebe', fontWeight: "bold", fontSize: "18px" }}>
                                <span>Get Started</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id='healthcare' >
                <Spacing md="100" />
                <DepartmentSectionStyle2
                    sectionTitleUp="Your Benefits"
                    sectionTitle="Healthcare Services"
                    data={healthcare}
                    handleGetStarted={handleGetStarted}
                />
            </div>
            <div id='complementary'>
                <Spacing md="100" />
                <DepartmentSectionStyle2
                    sectionTitleUp="Your Benefits"
                    sectionTitle="Complementary Services"
                    data={complementary}
                    handleGetStarted={handleGetStarted}
                />
            </div>
            <div id='valueAdded'>
                <Spacing md="100" />
                <DepartmentSectionStyle2
                    sectionTitleUp="Your Benefits"
                    sectionTitle="Value Added Services"
                    data={valueAdded}
                    handleGetStarted={handleGetStarted}
                />
            </div>
            <Spacing md="100" />
            <div className="container">
                <div className="cs_banner_text row">
                    <div className='col-xl-6 col-md-12'>
                        <h2 className="cs_banner_title cs_fs_72" style={{ color: '#0e6ebe' }}>Find the Right Plan for You</h2>
                        <p className="cs_banner_subtitle cs_fs_20 mb-0 cs_heading_color" style={{ color: '#000' }}>
                            Explore Our Membership Options and Start Your Journey to Better Health
                        </p>
                    </div>
                    <div className='col-xl-6 col-md-12 text-center'>
                        <Spacing md="50" lg="50" xl="100" />
                        <div className={`cs_btn cs_style_1`} onClick={handleGetStarted} style={{ color: '#0e6ebe', fontWeight: "bold", fontSize: "18px" }}>
                            <span>Get Started</span>
                            <i>
                                <img src="images/icons/arrow_white.svg" alt="Icon" />
                                <img src="images/icons/arrow_white.svg" alt="Icon" />
                            </i>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}